import parse from "html-react-parser";

/**
 * Coerce API / TipTap payloads to a string before html-react-parser.
 * Non-strings (null, objects, arrays) throw "First argument must be a string"
 * and take down the app via TKLErrorBoundary (header, home, Loop, etc.).
 */
export function asHtmlString(value) {
  if (typeof value === "string") return value;
  if (value == null) return "";
  return "";
}

export function safeHtmlParse(value) {
  return parse(asHtmlString(value));
}
